import { Cart } from '@commercetools/platform-sdk';

import { fromAxiosNutsJson, NutsJson, webstore } from '@/api';

export interface CreateCustomTrayResponse {
  cart?: Cart;
  cart_line?: {
    id: string;
    quantity_added: number;
  };
}

export async function addCustomTrayToCart(variantSku: string, variantContents: string[]) {
  const formData = new FormData();
  formData.append('quantity', '1');
  formData.append('tray-contents', variantContents.join(','));
  formData.append('size', variantSku);

  const result = await fromAxiosNutsJson(
    webstore.post<NutsJson<CreateCustomTrayResponse>>('/custom-trays/create', formData),
    { onRedirect: () => {} },
  );

  return result;
}
